import React, { useEffect, useState } from "react";
import { BiSolidCategory } from "react-icons/bi";
import { FaPlus } from "react-icons/fa";
import { TfiMenuAlt } from "react-icons/tfi";
import Navbar from "../../component/Navbar/Navbar";
import Sidebar from "../../component/sidebar/Sidebar";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteItem,
  getItems,
  selectitems,
  selectItemSuccess,
} from "../../redux/features/item/ItemSlice";
import { MdDelete, MdEdit } from "react-icons/md";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import "./Items.css";
import ingredient1 from "../../Asset/ingredient 1.png";
import ingredient2 from "../../Asset/ingredient 2.png";
import ItemLogo from "../../Asset/item logo.png";
import {
  filterItems,
  selectFilteredItems,
} from "../../redux/features/filter/FilterSlice";
import PreviewItemHistory from "./PreviewItemHistory";

export const sidebarSections = [
  {
    name: "Items",
    icon: <TfiMenuAlt />,
    path: "/items",
  },
  {
    name: "Categories",
    icon: <BiSolidCategory />,
    path: "/categories",
  },
  // {
  //   name: "Bases",
  //   image1: base1,
  //   image2: base2,
  //   path: "/bases",
  // },
  {
    name: "Ingredient",
    image1: ingredient1,
    image2: ingredient2,
    path: "/ingredients",
  },
  // {
  //   name: "Toppings",
  //   image1: topping1,
  //   image2: topping2,
  //   path: "/toppings",
  // },
  // {
  //   name: "Cheeses",
  //   image1: cheese1,
  //   image2: cheese2,
  //   path: "/cheeses",
  // },
];

const Items = () => {
  const [search, setSearch] = useState("");

  let items = useSelector(selectitems);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getItems());
  }, [dispatch]);

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  // delete item
  const confirmDelete = (id, name) => {
    if (!id || !name) {
      toast.error("ID or Name is undefined");
      return;
    }
    confirmAlert({
      title: "Delete This Item",
      message: `Are you sure to delete this ${name}?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removeItem(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };

  // start pagination
  const fliterItems = useSelector(selectFilteredItems);
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = fliterItems?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(fliterItems?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % fliterItems?.length;

    setItemOffset(newOffset);
  };
  // end pagination

  const isSuccess = useSelector(selectItemSuccess);

  const removeItem = async (id) => {
    await dispatch(deleteItem(id));
    if (isSuccess) {
      dispatch(getItems());
    }
  };

  useEffect(() => {
    dispatch(filterItems({ search, items }));
  }, [dispatch, search, items]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      {/* Navbar */}
      <Navbar page="Items" />

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div className="md:w-[30%] w-[35%] bg-white shadow-md">
          <Sidebar sidebarSections={sidebarSections} />
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8 relative overflow-y-auto  scrollbar-hide ">
          {/* Product List */}
          {items?.length > 0 ? (
            <>
              <div className="lg:w-full w-[35rem] mx-auto mb-10 ">
                <div className="flex lg:justify-end justify-start my-4 items-center ">
                  <input
                    type="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                    placeholder="Search by name..."
                  />
                </div>
                <div className="lg:space-y-4 space-y-2">
                  <div
                    className={`flex items-center justify-between lg:text-[1rem] text-[.8rem]  pb-0 w-full font-bold capitalize`}
                  >
                    <div className="flex items-center  lg:w-[55%] w-[50%]">
                      <span className="w-[20%]">Sr #</span>

                      <span className=" w-[80%]  ">name</span>
                    </div>

                    <div className="flex items-center lg:w-[45%] w-[50%]">
                      <div className=" w-[30%]">Inventory</div>

                      <div className=" w-[30%]">Price</div>

                      <div className="w-[40%]">Action</div>
                    </div>
                  </div>
                  {currentItems?.map((item, index) => {
                    return (
                      <div
                        key={item?._id}
                        className={`flex items-center justify-between lg:pt-4 pt-2 pb-0 border-t-2 border-[#DEDEDE] w-[full]
                        }`}
                      >
                        <div className="flex items-center lg:text-[1rem] text-[.8rem]  lg:w-[55%] w-[50%]">
                          <span className="w-[20%]">{index + 1}</span>

                          <span className="font-inter-600 text-wrap capitalize w-[80%] text-[#0D868C]">
                            {item?.name}
                          </span>
                        </div>

                        <div className="flex items-center lg:w-[45%] w-[50%] lg:text-[1rem] text-[.8rem]">
                          {item.itemType === "consumer" ? (
                            <span
                              title={`${item?.inventory} ${item?.inventoryUnit}`}
                              className={`${
                                item.inventory < 10
                                  ? "text-[#ad3a3a]"
                                  : "text-[#1E1E1E]"
                              }  font-inter-400 w-[30%]`}
                            >
                              {(item?.inventory / item?.conversionRate).toFixed(
                                1
                              )}{" "}
                              {item?.purchaseUnit}
                            </span>
                          ) : (
                            <span className="w-[30%]">N/A</span>
                          )}

                          {item?.price > 0 && (
                            <span
                              className={`text-[#1E1E1E] lg:text-[1rem] text-[.8rem] font-inter-400 w-[30%] `}
                            >
                              {priceSymbol} {item?.price}
                            </span>
                          )}

                          <div className="flex items-center lg:gap-3 gap-1.5 w-[40%]">
                            {item.itemType === "consumer" ? (
                              <PreviewItemHistory
                                trackHistory={item?.trackHistory}
                              />
                            ) : (
                              ""
                            )}
                            <NavLink
                              className="bg-[#0D868C] text-center text-white p-1 rounded-lg cursor-pointer"
                              to={`/editItem/${item._id}`}
                            >
                              <MdEdit className="lg:size-6 size-5" />
                            </NavLink>
                            <span
                              onClick={() =>
                                confirmDelete(item._id, item?.name)
                              }
                              className="bg-[#f1524d] text-center text-white p-1 rounded-lg cursor-pointer"
                            >
                              <MdDelete className="lg:size-6 size-5" />
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {fliterItems?.length > itemsPerPage && (
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="Prev"
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="page-num"
                    previousLinkClassName="page-num"
                    nextLinkClassName="page-num"
                    activeLinkClassName="activePage"
                  />
                )}
              </div>

              {/* Add New Item Button */}
              <NavLink
                to={"/createItem"}
                className="fixed bottom-8 right-10 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
              >
                <FaPlus className="md:text-xl text-[1rem]" />
              </NavLink>
            </>
          ) : (
            <div className="flex items-center justify-center md:w-full w-[27rem]">
              <div className="md:w-[30rem] w-[25rem] lg:w-[38rem]  relative  lg:h-[30rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                <img src={ItemLogo} className="mb-2" alt="Logo" />

                <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                  You have no item yet
                </p>
                <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                  To add a item, press the (+) button
                </p>
                <NavLink
                  to={"/createItem"}
                  className=" absolute bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <FaPlus className="md:text-xl text-[1rem]" />
                </NavLink>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Items;
